import classnames from 'classnames';

import BuilderContent from 'components/Builder/BuilderContent';
import styles from 'components/HealthcareEntries/Content/content.module.scss';
import Disclaimer from 'components/HealthcareEntries/Disclaimer';
import LearningCenterGate from 'components/HealthcareEntries/LearningCenterGate';
import LearningCenterIndicator from 'components/HealthcareEntries/LearningCenterIndicator';
import RelatedContent from 'components/HealthcareEntries/RelatedContent';

import type { BuilderContentProps } from 'components/Builder/BuilderContent';
import type { FC } from 'react';

interface ContentProps extends BuilderContentProps {
  publishedDate?: string | null;
}

const Content: FC<ContentProps> = ({ components, content, model, publishedDate }) => {
  const isLearningCenterOnly = content?.data?.templateInfo?.siteAvailability === 'LC Only';
  const isHCIOnly = content?.data?.templateInfo?.siteAvailability === 'HCI Only';
  const myMagMutualSlug = content?.data?.url?.replaceAll('healthcare-insights', 'content-library');
  const slug = !isLearningCenterOnly ? myMagMutualSlug : '/content-library';

  return (
    <section className={styles.contentLayout}>
      <div className={styles.contentBodyContainer}>
        <div className={styles.contentLayoutBody}>
          <div
            className={classnames(styles.builderContent, {
              [styles.articleBuilderContent]: model === 'template-article',
            })}
          >
            <BuilderContent components={components} content={content} model={model} />
            {publishedDate && !isLearningCenterOnly && (
              <div className={styles.publishedDate}>
                <p>{publishedDate}</p>
              </div>
            )}
          </div>
          <LearningCenterGate slug={slug} isHCIOnly={isHCIOnly} />
          <Disclaimer />
        </div>
        <div className={styles.contentSideBarContainer}>
          <div className={styles.sideBarItem}>
            <LearningCenterIndicator slug={slug} isHCIOnly={isHCIOnly} />
          </div>
          <div className={styles.sideBarItem}>
            <RelatedContent queryData={content} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Content;
